// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referHotelImage p[data-v-f46f3c42] {\n  margin-bottom: 0.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
